import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private baseUrl = `${environment.apiUrl}/company`;
  private baseUrl2 = `${environment.apiUrlV2}/company`;
  private baseUrl3 = `${environment.apiUrlV3}/company`;
  private baseUrl4 = `${environment.apiUrlV2}`;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http
      .get<any>(this.baseUrl2 + '/ListActiveCompanies', {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getCNPJ(value) {
    return this.http
      .get<any>(this.baseUrl2 + '/CompanyByCnpjRFB/' + value, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  add(body) {
    return this.http
      .post<any>(this.baseUrl2 + '/RegisterNewCompany', body, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  handleRules(insuranceId:string, list: string[]) {
    let statusProviderChangeObj = {
      insuranceId: insuranceId,
      statusBlockedProvider: list
    }
    return this.http
      .post<any>(this.baseUrl4 + '/inspectionStatusProviderChange/handlerRuleStatusProvider', statusProviderChangeObj, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }
  handleRulesBlocked(insuranceId:string, list: string[]) {
    let statusProviderChangeObj = {
      insuranceId: insuranceId,
      statusBlockedProvider: list
    }
    return this.http
      .post<any>(this.baseUrl4 + '/inspectionStatusProviderChange/handlerRuleStatusBlockProvider', statusProviderChangeObj, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  deleteRule(id) {
    return this.http
      .delete<any>(this.baseUrl4 + '/inspectionStatusProviderChange/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getRules(value) {
    return this.http
      .get<any>(this.baseUrl4 + '/inspectionStatusProviderChange/' + value, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  edit(body) {
    return this.http
      .put<any>(this.baseUrl3 + '/' + body.id, body, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  getProviders() {
    return this.http
      .get<any>(this.baseUrl2 + '/ListActiveProviders', {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getBrokers(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl2}/Brokers`, {
        headers: this.headers,
        observe: 'response',
      });
  }

  getBrokersByIdCompany(companyId) {
    return this.http
      .get<any>(`${this.baseUrl2}/ListActiveBrokers/${companyId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getProvidersById(id) {
    return this.http
      .get<any>(this.baseUrl2 + '/InsuranceCompanyById/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  relationshipPost(obj) {
    return this.http
      .post<any>(this.baseUrl + '/RelationshipPost', obj, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  relationshipPut(obj) {
    return this.http
      .put<any>(this.baseUrl + '/RelationshipPut', obj, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(tap((res) => { }))
      .toPromise();
  }

  getBranchesById(id) {
    return this.http
      .get<any>(this.baseUrl2 + '/GetBranchesCompanyById/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  deleteCompany(id) {
    return this.http
      .delete<any>(this.baseUrl2 + '/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  activeCompany(id) {
    return this.http
      .put<any>(this.baseUrl2 + '/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getById(id) {
    return this.http
      .get<any>(this.baseUrl3 + '/CompanyById/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  // HUB-1629: CSV dos campos do Laudo liberados p/ corretor, pela seguradora do laudo (InsuranceCompany.Id)
  getBrokerReportFields(insuranceId) {
    return this.http
      .get(`${this.baseUrl3}/BrokerReportFields/${insuranceId}`, {
        headers: this.headers,
        responseType: 'text', // backend devolve o CSV como text/plain (nao JSON)
      })
      .toPromise();
  }

  getByIdForBroker(idBrokerInCompany, companyId) {
    return this.http
      .get<any>(`${this.baseUrl3}/CompanyByIdForBroker/${idBrokerInCompany}/${companyId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getChangeLogByCompany(companyId: string) {
    return this.http
      .get<any>(`${this.baseUrl3}/ChangeLogByCompany/${companyId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  listActiveProviders() {
    return this.http
      .get<any>(this.baseUrl2 + '/ListActiveProviders')
      .toPromise();
  }

  newListActiveProviders() {
    return this.http
      .get<any>(this.baseUrl2 + '/ListActiveProviders');
  }

  registerListNewCompany(data: any[]) {
    return this.http
      .post<any>(this.baseUrl2 + '/RegisterListNewCompany', data)
      .toPromise();
  }

  getProvidersByIdCompany(idCompany) {
    return this.http
      .get<any>(`${this.baseUrl2}/ProvidersByIdCompany/${idCompany}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  getBranchesOfCompany(id) {
    return this.http
      .get<any>(this.baseUrl3 + '/GetBranchesCompanyByIdChangeProvider/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getDestinySurveyType(idCompany: string): Observable<{ vehicle: number; truck: number; motorcicle: number }> {
    const mockData = { vehicle: 1, truck: 4, motorcicle: 1 };
    return of(mockData);
  }

  saveDestinySurveyType(idCompany: string, data: { vehicle: number; truck: number; motorcicle: number }) {
    const mockResponse = {
      success: true,
      message: 'Mocked POST request was successful!',
    };
    
    return of(mockResponse);
  }

}
